import { createAuthClient } from "better-auth/react";
import { emailOTPClient, multiSessionClient } from "better-auth/client/plugins";
import { environment } from "./services/enviroment";

export const authClient = createAuthClient({
  baseURL: `${environment.openBaas}/v1/auth`,
  basePath: `http://localhost:3001`,
  plugins: [emailOTPClient(), multiSessionClient()],
});
